var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadache(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "126px",
    viewBox: "0 0 102 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "204E464F-434B-45B9-B439-57053DB6945A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-402.000000, -375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(405.000000, 378.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.33716,120.73134 C55.33716,114.13614 53.79816,103.22844 72.14676,106.07334 C80.31816,107.34444 81.90816,90.33834 84.30636,85.40004 C85.39986,83.16084 86.64546,81.42744 89.22906,80.96544 C91.11006,80.62764 93.24576,81.25164 94.83306,79.88814 C96.15936,78.76074 96.44856,76.78284 95.89866,75.18564 C95.89866,75.18564 91.25106,65.90724 86.61306,58.40124 C83.37756,53.17434 85.00236,48.35364 85.00236,42.50694 C85.00236,19.02804 65.97426,0.00024 42.50676,0.00024 C19.03266,0.00024 6e-05,19.02804 6e-05,42.50694 C6e-05,49.94364 1.92036,56.94084 5.31516,63.09264 C16.71036,85.10664 14.99976,120.73134 14.99976,120.73134",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 4.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97137,33.85497 L15.42177,28.59057 C15.70617,28.31607 16.14177,28.27347 16.47387,28.48767 L26.95587,35.25357 C27.40947,35.54667 27.47877,36.18297 27.09867,36.56667 L25.64007,38.03907 C25.33017,38.35167 25.31007,38.84877 25.59357,39.18567 L30.12327,44.56167 C30.66537,45.20517 30.04377,46.16097 29.23557,45.92637 L16.96977,42.36297 C16.34727,42.18237 16.14777,41.39937 16.60797,40.94277 L18.17067,39.39207 C18.61437,38.95167 18.44727,38.19897 17.85897,37.98777 L10.27497,35.26707 C9.68187,35.05407 9.51807,34.29267 9.97137,33.85497",
    id: "Fill-3",
    fill: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.88128,23.48214 L72.70638,28.32864 C73.00998,28.58154 73.09968,29.01024 72.92268,29.36334 L67.33518,40.51794 C67.09308,41.00094 66.46818,41.13894 66.04518,40.80264 L64.42338,39.51264 C64.07898,39.23844 63.58218,39.27264 63.27858,39.59094 L58.42578,44.67744 C57.84498,45.28644 56.82738,44.77224 56.97318,43.94334 L59.18328,31.36344 C59.29548,30.72504 60.05208,30.44154 60.55608,30.84924 L62.26728,32.23434 C62.75328,32.62734 63.48318,32.37954 63.62898,31.77174 L65.51058,23.93754 C65.65758,23.32464 66.39678,23.07924 66.88128,23.48214",
    id: "Fill-5",
    fill: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.68711,11.08104 L47.98851,13.10784 C48.36921,13.21344 48.62691,13.56744 48.61071,13.96224 L48.09711,26.42754 C48.07461,26.96754 47.56161,27.34974 47.03781,27.21684 L45.02901,26.70654 C44.60241,26.59824 44.16381,26.83314 44.01771,27.24834 L41.68191,33.87894 C41.40261,34.67274 40.26351,34.62174 40.05591,33.80634 L36.90471,21.42804 C36.74481,20.79984 37.31841,20.23104 37.94511,20.39604 L40.07421,20.95584 C40.67901,21.11484 41.24271,20.58894 41.12601,19.97484 L39.62421,12.05904 C39.50661,11.43984 40.07991,10.91244 40.68711,11.08104",
    id: "Fill-7",
    fill: "#ED7330"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadache);
export default __webpack_public_path__ + "static/media/headache.a6725c93.svg";
export { ForwardRef as ReactComponent };